import { APP_VERSION } from "./service/ENUM";

const SW_VERSION = (APP_VERSION && APP_VERSION.toString()) || process.env.REACT_APP_SW_VERSION || "dev";

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;

  const register = () => {
    const swUrl = `/sw.js?v=${encodeURIComponent(SW_VERSION)}`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        const activateWaiting = () => {
          if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
          }
        };

        if (registration.waiting) {
          activateWaiting();
        }

        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              activateWaiting();
            }
          };
        };

        navigator.serviceWorker.addEventListener("controllerchange", () => {
          window.location.reload();
        });
      })
      .catch(() => {
        /* ignore registration errors */
      });
  };

  if (document.readyState === "complete") {
    register();
  } else {
    window.addEventListener("load", register, { once: true });
  }
}
